import React from 'react';

import { Typography } from 'pixel-react';

import styles from './FlagTab.module.scss';
import type { FlagTabProps } from '../chatbot/types';

const FlagTab: React.FC<FlagTabProps> = ({
  title,
  icon,
  onClick,
  width,
  fontSize,
  borderGradient,
  backgroundGradient,
}) => {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      }}
      className={styles.flag_tab_wrapper}
      style={{
        background: borderGradient,
        width,
      }}
    >
      {' '}
      <div className={styles.middle_layer}>
        <div
          className={styles.flag_tab_content}
          style={{
            background: backgroundGradient,
            fontSize,
          }}
        >
          <div className={styles.icon_wrapper}>{icon}</div>
          <Typography
            color="var(--table-column-text-color)"
            fontSize={fontSize}
            fontWeight="semi-bold"
          >
            {title}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default FlagTab;
